// extracted by mini-css-extract-plugin
export default {"logoWrapper":"LogoWrapper_logoWrapper__0-R4A","logoIconRotation":"LogoWrapper_logoIconRotation__cQpHl"};